module.exports = __webpack_public_path__ + "static/media/default.0f7f733e.svg";